function tfgSetLineItemProperty(formData, key, value) {
  if (!formData || !key || value === undefined || value === null) return;

  const normalizedValue = String(value).trim();
  if (!normalizedValue) return;

  formData.set(`properties[${key}]`, normalizedValue.slice(0, 255));
}

function tfgGetPdpUpsellSourceHandle() {
  try {
    const sourceHandle = new URLSearchParams(window.location.search).get('pdp_src');
    if (!sourceHandle || !/^[a-z0-9][a-z0-9-]*$/i.test(sourceHandle)) return '';
    return sourceHandle;
  } catch (error) {
    return '';
  }
}

function tfgGetPdpUpsellSourceTitle(sourceHandle) {
  if (!sourceHandle) return '';

  const cards = document.querySelectorAll('[data-pdp-product-option-card]');
  for (const card of cards) {
    if (card.getAttribute('data-product-handle') === sourceHandle) {
      return card.getAttribute('data-product-title') || '';
    }
  }

  const options = document.querySelector('[data-pdp-product-options]');
  return options?.getAttribute('data-pdp-product-source-title') || '';
}

window.tfgApplyUpsellTrackingProperties = function (formData, form, productForm) {
  const formElement = productForm || form?.closest('product-form');
  if (!formData || !formElement) return formData;

  const targetHandle = formElement.dataset.productHandle || '';
  const targetTitle = formElement.dataset.productTitle || '';

  if (formElement.dataset.cartUpsell === 'true') {
    tfgSetLineItemProperty(formData, '_cart_upsell', 'true');
    tfgSetLineItemProperty(formData, '_cart_upsell_type', formElement.dataset.cartUpsellType);
    tfgSetLineItemProperty(formData, '_cart_upsell_source_handle', formElement.dataset.cartUpsellSourceHandle);
    tfgSetLineItemProperty(formData, '_cart_upsell_source_title', formElement.dataset.cartUpsellSourceTitle);
    tfgSetLineItemProperty(formData, '_cart_upsell_target_handle', targetHandle);
    tfgSetLineItemProperty(formData, '_cart_upsell_target_title', targetTitle);
    return formData;
  }

  const pdpSourceHandle = tfgGetPdpUpsellSourceHandle();
  if (pdpSourceHandle && targetHandle && pdpSourceHandle !== targetHandle) {
    tfgSetLineItemProperty(formData, '_pdp_upsell', 'true');
    tfgSetLineItemProperty(formData, '_pdp_upsell_source_handle', pdpSourceHandle);
    tfgSetLineItemProperty(formData, '_pdp_upsell_source_title', tfgGetPdpUpsellSourceTitle(pdpSourceHandle));
    tfgSetLineItemProperty(formData, '_pdp_upsell_target_handle', targetHandle);
    tfgSetLineItemProperty(formData, '_pdp_upsell_target_title', targetTitle);
  }

  return formData;
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        window.tfgApplyUpsellTrackingProperties?.(formData, this.form, this);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            return this.normalizeDuplicateVariantLines(response).then((cartData) => {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: cartData,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(cartData);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(cartData);
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getLineProperties(item) {
        return item.properties && typeof item.properties === 'object' ? item.properties : {};
      }

      hasOnlyHiddenProperties(item) {
        return Object.keys(this.getLineProperties(item)).every((key) => key.charAt(0) === '_');
      }

      getSellingPlanKey(item) {
        return item.selling_plan_allocation?.selling_plan?.id || '';
      }

      normalizeDuplicateVariantLines(addResponse) {
        if (
          !this.cart ||
          typeof routes.cart_update_url === 'undefined' ||
          typeof routes.cart_url === 'undefined'
        ) {
          return Promise.resolve(addResponse);
        }

        return fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' })
          .then((response) => response.json())
          .then((cartData) => this.mergeDuplicateVariantLines(cartData, addResponse))
          .catch((error) => {
            console.error(error);
            return addResponse;
          });
      }

      mergeDuplicateVariantLines(cartData, addResponse) {
        if (!Array.isArray(cartData?.items) || !cartData.items.length) return Promise.resolve(addResponse);

        const groups = new Map();
        cartData.items.forEach((item) => {
          if (!item?.key || !item.variant_id || !this.hasOnlyHiddenProperties(item)) return;

          const groupKey = `${item.variant_id}:${this.getSellingPlanKey(item)}`;
          const group = groups.get(groupKey) || [];
          group.push(item);
          groups.set(groupKey, group);
        });

        const updates = {};
        groups.forEach((group) => {
          if (group.length < 2) return;

          const addedLineKey = addResponse?.key || '';
          const keeper = group.find((item) => item.key !== addedLineKey) || group[0];
          const totalQuantity = group.reduce((sum, item) => sum + item.quantity, 0);

          updates[keeper.key] = totalQuantity;
          group.forEach((item) => {
            if (item.key !== keeper.key) updates[item.key] = 0;
          });
        });

        if (!Object.keys(updates).length) return Promise.resolve(addResponse);

        const body = JSON.stringify({
          updates,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
            return addResponse;
          });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          else this.submitButtonText.textContent = this.submitButton.dataset.soldOutText || window.variantStrings.soldOut;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.submitButton.dataset.availableText || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
